import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { tvMerge } from '../../utils/tailwind';
import { Box } from '../Box/Box';
import { Button } from '../Button/Button';
import { IconButton } from '../IconButton/IconButton';
import { SuperEllipse } from '../SuperEllipse/SuperEllipse';
import { Typography } from '../Typography/Typography';
import { bar, pageButton } from './styles';
import { getPagination } from './usePagination';
export const Pagination = (props) => {
    const { currentPage, totalPages, onChange, className } = props;
    const itemList = getPagination(currentPage, totalPages);
    const handlePreviousClick = () => {
        onChange === null || onChange === void 0 ? void 0 : onChange(currentPage - 1);
    };
    const handleNextClick = () => {
        onChange === null || onChange === void 0 ? void 0 : onChange(currentPage + 1);
    };
    const handleClick = (item) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(item);
    };
    return (_jsxs("div", { className: tvMerge(['flex', className]), children: [_jsx(IconButton, { variant: "text", name: "chevron-left", size: 32, disabled: currentPage === 1, onClick: handlePreviousClick, "aria-label": "previous page" }), _jsx("div", { className: bar(), children: itemList.map((item, i) => {
                    const key = `${item}-${i}`;
                    if (item === '...') {
                        return (_jsx(Box, { display: "flex", alignItems: "center", children: _jsx(Typography, { variant: "body", children: "..." }) }, key));
                    }
                    return item === currentPage ? (_jsx(SuperEllipse, { invertedColor: true, size: 40, text: item.toString(), className: "-my-4 mx-2" }, key)) : (_jsx(Button, { type: "button", size: 32, variant: "text", onClick: () => handleClick(item), className: pageButton(), children: item }, key));
                }) }), _jsx(IconButton, { variant: "text", name: "chevron-right", size: 32, disabled: currentPage === totalPages, onClick: handleNextClick, "aria-label": "next page" })] }));
};
